import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useGetPipeline, useDeletePipeline, useRemovePipeline, useRemovePipelineIntegrations } from '@ion/api';

import { useModalContext, MODAL_ACTIONS } from '@ion/app/src/pipelines/ModalContext';

export default function useConfirmDeleteModalProps() {
  const {
    errorMsg,
    setErrorMsg,
    modalState: { pipeline, activeModal },
    closeModal,
  } = useModalContext();
  const open = Boolean(pipeline?.id && activeModal === MODAL_ACTIONS.DELETE_PIPELINE);

  const [deployedPipelineLoading, setDeployedPipelineLoading] = useState(true);
  const [getDeployedPipeline, { data: deployedPipeline, error: deployedPipelineError }] = useGetPipeline({
    transformNotDeployed: true,
  });

  const [confirmInputValue, setConfirmInputValue] = useState('');

  const [removePipeline] = useRemovePipeline();
  const [removePipelineIntegrations] = useRemovePipelineIntegrations();
  const [deletePipeline] = useDeletePipeline({
    onCompleted: () => {
      removePipelineIntegrations(pipeline.pipelineIntegrations);
      removePipeline({ pipelineId: pipeline.id });
      closeModal();
    },
    onError: err => {
      setErrorMsg(err?.errorMsg);
    },
  });
  const onDelete = () => {
    deletePipeline({ clusterId: pipeline.cluster.id, writekey: pipeline.writekey });
  };

  useEffect(() => {
    async function fetchDeployedPipeline() {
      await getDeployedPipeline({ clusterId: pipeline.cluster.id, writekey: pipeline.writekey });
      setDeployedPipelineLoading(false);
    }

    if (open) {
      fetchDeployedPipeline();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return {
    DialogProps: {
      open,
      onClose: closeModal,
      fullWidth: true,
      maxWidth: 'xl',
    },
    loading: deployedPipelineLoading,
    pipeline,
    deployedIntegrations: deployedPipeline?.pipeline?.integrations || [],
    deployedPipelineError,
    errorMsg,
    setErrorMsg,
    onClose: closeModal,
    deleteDisabled: confirmInputValue !== pipeline?.writekey || deployedPipelineLoading,
    onDelete,
    setConfirmInputValue,
  };
}

useConfirmDeleteModalProps.propTypes = {
  setErrorMsg: PropTypes.func,
};
